import { createFileRoute } from '@tanstack/react-router'
import { EnPrivacyPage } from '~/components/marketing/en/en-privacy-page'
import { marketingPageHead } from '~/lib/site-meta'

const TITLE = 'Privacy Policy | Planno'
const DESCRIPTION =
  'How Planno collects, uses, stores, and protects your personal data. Legal bases under the LGPD, cookies, your rights, and how to contact us. English translation; the Portuguese version governs.'

export const Route = createFileRoute('/en/privacy-policy')({
  component: EnPrivacyPage,
  head: () =>
    marketingPageHead({
      description: DESCRIPTION,
      locale: 'en',
      path: '/en/privacy-policy',
      title: TITLE,
    }),
})
